"use client";

import React, { useState, useEffect } from "react";
import { Menu, X, Terminal } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function NavContent() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [isOpen, setIsOpen] = useState(false);
  if (loading) {
    return <div data-section-id="219909" className="flex gap-4 items-center">
        <div className="h-8 w-20 bg-muted animate-pulse rounded-none hidden md:block" />
        <div className="h-8 w-20 bg-muted animate-pulse rounded-none hidden md:block" />
        <div className="h-8 w-8 bg-muted animate-pulse rounded-none md:hidden" />
      </div>;
  }
  return <>
      {}
      <NavigationMenu className="hidden md:flex">
        <NavigationMenuList className="gap-8">
          {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
              <NavigationMenuLink asChild>
                <Link to={item.href || "#"} className="font-default text-sm font-medium relative py-2 text-foreground hover:text-foreground/80 transition-colors group">
                  {item.label}
                  <span className="absolute bottom-0 left-1/2 w-0 h-0.5 bg-secondary -translate-x-1/2 transition-all duration-300 group-hover:w-full" />
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>)}
        </NavigationMenuList>
      </NavigationMenu>

      {}
      <Button variant="ghost" size="icon" className="md:hidden text-foreground hover:bg-accent/50 rounded-none" onClick={() => setIsOpen(!isOpen)} aria-label="Toggle Menu">
        {isOpen ? <X size={24} /> : <Menu size={24} />}
      </Button>

      {}
      {isOpen && <div className="absolute top-full left-0 w-full bg-background/95 backdrop-blur-xl border-b border-border md:hidden flex flex-col p-6 gap-4 shadow-2xl z-50">
          {menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} data-index={i} className="font-default text-lg py-3 text-foreground hover:text-foreground/80 border-b border-border/30 transition-colors" onClick={() => setIsOpen(false)}>
              {item.label}
            </Link>)}
          <Button asChild className="mt-6 w-full shadow-none bg-primary text-background font-bold font-default border border-primary/50 rounded-none">
            <Link to="#" onClick={() => setIsOpen(false)}>
              <Terminal className="mr-2" size={18} />
              Hướng Dẫn Miễn Phí
            </Link>
          </Button>
        </div>}
    </>;
}
export default function SystemHeader() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <section id="header" className={`bg-background text-foreground sticky top-0 z-50 transition-all duration-500 ${isScrolled ? "bg-background/85 backdrop-blur-xl border-b border-border shadow-sm" : "bg-background border-b border-transparent"}`}>
      <div className="container mx-auto px-4 h-20 flex items-center justify-between relative">
        {}
        <div className="flex-shrink-0 z-20">
          <Link to="/" className="block">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1630241/img/snowycrazy_system_logo.png" alt="Vietomy" className="h-7 w-auto object-contain" />
          </Link>
        </div>

        {}
        <div className="hidden md:flex absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-10">
          <Button asChild className="shadow-none bg-primary text-background hover:bg-primary/90 font-bold font-default px-8 py-6 rounded-none border border-primary/50 transition-all duration-300">
            <Link to="#">
              <Terminal className="mr-2" size={20} />
              Hướng Dẫn Miễn Phí
            </Link>
          </Button>
        </div>

        {}
        <div className="flex items-center z-20">
          <MenuProvider menu_id="44">
            <NavContent />
          </MenuProvider>
        </div>
      </div>
    </section>;
}